import {EpRadarQuadrant, EpRadarRing} from "./TechRadar";

export const rings = new Array<EpRadarRing>();
rings.push({ id: 'adopt', name: 'ADOPT', color: '#93c47d' });
rings.push({ id: 'trial', name: 'TRIAL', color: '#93d2c2' });
rings.push({ id: 'assess', name: 'ASSESS', color: '#fbdb84' });
rings.push({ id: 'hold', name: 'HOLD', color: '#efafa9' });

export const quadrants = new Array<EpRadarQuadrant>();
quadrants.push({ id: 'infrastructure', name: 'Infrastructure' });
quadrants.push({ id: 'data', name: 'Data' });
quadrants.push({ id: 'languagesframeworks', name: 'Languages & Frameworks' });
quadrants.push({ id: 'techniques', name: 'Techniques' });